import { createClient } from "@supabase/supabase-js";

// Mismos valores que la app actual (app/app.js líneas 4-7). La anon key es
// pública por diseño: todo el alcance por rol/sucursal se impone en Postgres
// (api_scope_sucursales), nunca en el navegador.
// Con un .env.local (VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY) el Radar local
// apunta a la base de PRUEBAS; sin él, a producción como siempre (mismo diseño que PILOT).
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://nunoemlqhfkyihrwinxk.supabase.co";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im51bm9lbWxxaGZreWlocndpbnhrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQ1MzAxNDMsImV4cCI6MjEwMDEwNjE0M30.adXANYpBxHtzouZR3AKWoEL_DGIwgUzwlnO6MNW0uKw";

// El enlace del correo (invitación o "olvidé mi contraseña") llega con todo en
// el HASH: #access_token=...&type=invite. Hay que leerlo AQUÍ, a nivel de
// módulo y ANTES de createClient, porque supabase-js lo canjea por una sesión
// y lo BORRA de la URL; leerlo dentro de un componente ya es tarde y la
// pantalla de crear contraseña nunca aparecería. Mismo truco que app.js:142.
const hashEntrada = new URLSearchParams(
  typeof location !== "undefined" ? location.hash.slice(1) : "",
);

/** "invite" | "recovery" cuando se abrió un enlace de correo; null si no. */
export const TIPO_ENLACE = hashEntrada.get("type");

/** Enlace de correo vencido o ya usado: Supabase lo avisa en el mismo hash
 *  (#error=access_denied&error_code=otp_expired) y NO crea sesión. */
export const ERROR_ENLACE = hashEntrada.get("error_code") ?? hashEntrada.get("error");

export const supa = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export const EDGE_INVITAR = `${SUPABASE_URL}/functions/v1/admin-invitar-usuario`;
